import { useContext, useState } from 'react'

import { Tooltip } from 'antd'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComment } from '@fortawesome/pro-solid-svg-icons'

import { ScheduleChatRoomsContext } from '../../../../Providers/ScheduleChatRooms'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { ColorsPalette } from '../../../../config/colors'

const MessageIndicator = ({ shift, hasMessage, isUnread }) => {
  const t = useSelector(selectTranslate)
  const { setHandler } = useContext(ScheduleChatRoomsContext)
  const [isRead, setIsRead] = useState(!isUnread)

  const handleMessageClick = () => {
    if (hasMessage) {
      setIsRead(true)
      setHandler({
        shift,
        callback: null
      })
    }
  }

  return (
    <Tooltip title={hasMessage ? t('tooltip.open.messages') : ''}>
      <td
        style={{ width: '30px', textAlign: 'center', cursor: hasMessage ? 'pointer' : 'default' }}
        onClick={handleMessageClick}
      >
        {hasMessage && <FontAwesomeIcon icon={faComment} color={isRead ? ColorsPalette.FIRST : ColorsPalette.ERROR_BORDER} />}
      </td>
    </Tooltip>
  )
}

export default MessageIndicator
